import React from 'react';

function SubscribeButton({ size, onClick }) {
  return (
    <a className={`subscribe-${size}-button`} href="/subscribe" onClick={onClick}><div className={`subscribe-${size}-button-left-arrow`}></div>SUBSCRIBE<div className={`subscribe-${size}-button-right-arrow`}></div></a>
  );
}

export default SubscribeButton;
